<template>
    <div class=" m-0">
        <slot name="body">
            <div class="list-group list-custom-small" v-if="taskModel!=null">
                <div>
                    <i class="fa font-13 ml-2 fa-hashtag color-yellow1-dark"></i>
                    <span>{{lableText('TaskNo')??'شماره وظیفه'}}: </span>
                    <b>{{taskModel.taskNo}}</b>
                </div>
                <div>
                    <i class="fa font-13 ml-2 fa-calendar color-blue2-dark"></i>
                    <span>{{lableText('TaskDate')??'تاریخ ثبت'}}: </span>
                    <b>{{taskModel.taskDate}}</b>
                </div>
                <div>
                    <i class="fa font-13 ml-2 fa-check-square color-green1-dark"></i>
                    <span>{{lableText('Title')??'عنوان'}}: </span>
                    <b>{{taskModel.title}}</b>
                </div>
                <div>
                    <i class="fa font-13 ml-2 fa-user-check color-red1-dark"></i>
                    <span>ارجاع دهنده: </span>
                    <b>{{taskModel.referrerFolderUserTitle}}</b>
                </div>
                <div>
                    <i class="fa font-13 ml-2 fa-user-plus color-orange-light"></i>
                    <span>ارجاع گیرنده: </span>
                    <b>{{taskModel.receiverUserTitle}}</b>
                </div>
                <div>
                    <i class="fa font-13 ml-2 fa-star color-pink1-light"></i>
                    <span>{{lableText('PriorityId')??'اولویت'}}: </span>
                    <b>{{taskModel.priorityTitle}}</b>
                </div>
                <div>
                    <i class="fa font-13 ml-2 fa-calendar-check color-green2-dark"></i>
                    <span>{{lableText('StartDateTime')??'تاریخ و ساعت شروع'}}: </span>
                    <b class="d-inline-block ltr">{{taskModel.startDateTime}}</b>
                </div>
                <div>
                    <i class="fa font-13 ml-2 fa-history color-yellow1-light"></i>
                    <span>زمان معین شده: </span>
                    <b>{{taskModel.suggestedPersonTime}}</b>
                </div>
                <div>
                    <i class="fa font-13 ml-2 fa-calendar-times color-red1-dark"></i>
                    <span>{{lableText('EndDateTime')??'زمان پایان'}}: </span>
                    <b class="d-inline-block ltr">{{taskModel.endDateTime}}</b>
                </div>
                <div class="border-bottom-0">
                    <i class="fa font-13 ml-2 fa-edit color-brown1-dark"></i>
                    <span>{{lableText('Description')??'توضیحات'}} :</span>
                    <div class="v-100 div-description" v-html="taskModel.taskFolderDescription"></div>
                </div>
                <div class="container">
                    <att-list v-if="taskModel!=null" v-bind:destination="'TaskFolder'" :oldAttList="taskModel.attList" :hasLocation="true"></att-list>
                </div>

            </div>
        </slot>
    </div>



</template>
<script>

    import AttList from '../Components/AttList.vue';
    export default {
        components: {
            "att-list": AttList,
        },
        props: ['taskId', 'taskFolderId'],
        data() {
            return {
                model: null,
                taskModel:null
            };
        },
        created() {
            this.GetTaskInfoFromServer();
        },
        methods: {
            GetTaskInfoFromServer() {
                this.$http.get("Task/GetTaskInfo", {
                    params: {
                        taskId: this.taskId,
                        taskFolderId: this.taskFolderId
                    }
                })
                    .then(data => {
                        this.taskModel = data.data;
                    });
            },
        }

    };
</script>
<style>
       .modal-mask {
           position: fixed;
           z-index: 9998;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background-color: rgba(0, 0, 0, 0.5);
           display: table;
           transition: opacity 0.3s ease;
       }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

       .modal-container {
           width: 300px;
           margin: 0px auto;
           background-color: #fff;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
       }

       .modal-header h3 {
           margin-top: 0;
           color: #42b983;
       }

       .modal-body {
           margin: 20px 0;
           line-height: 1;
       }

       .modal-default-button {
           float: right;
       }


       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(2);
               transform: scale(2);
           }
</style>
